import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { mq } from '../../../../../styles/mixins';

export const ItemText = styled.div`
  font-family: var(--font-base);
  font-size: 20px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0;
  text-align: left;
  color: #ffffff;
`;

export const SocialItemLink = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 0.5rem;
  gap: 1.5rem;
  padding: 16px 20px;
  background: #0e4ed7;
  text-decoration: none;
  white-space: nowrap;

  ${mq.large(css`
    padding: 32px 40px;
  `)}

  &:hover {
    background: linear-gradient(22.45deg, #0e4ed7 3.28%, #f94743 102.02%);
    /* drop shadow */

    box-shadow: 8px 8px 24px rgba(23, 0, 89, 0.29);
  }
`;
export const IconWrapper = styled.div`
  width: 64px;
  height: 64px;
`;
